import React from 'react';
import { Linkedin, Instagram, Youtube, Sparkle } from 'lucide-react';

const YEAR = new Date().getFullYear();

// Logo oficial de X (no existe como icono oficial en lucide-react, lo
// inyectamos como SVG inline con la forma corporativa actual).
const XLogo: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.451-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117Z" />
  </svg>
);

const SOCIALS: {
  href: string;
  label: string;
  Icon: React.ComponentType<{ size?: number }>;
}[] = [
  {
    href: 'https://www.linkedin.com/company/novagob',
    label: 'LinkedIn',
    Icon: Linkedin,
  },
  {
    href: 'https://x.com/novagob',
    label: 'X',
    Icon: XLogo,
  },
  {
    href: 'https://www.instagram.com/novagob/',
    label: 'Instagram',
    Icon: Instagram,
  },
  {
    href: 'https://www.youtube.com/@FundacionNovaGob',
    label: 'YouTube',
    Icon: Youtube,
  },
];

const LandingFooter: React.FC = () => (
  <footer className="landing-footer-ext">
    <div className="landing-container landing-footer-top">
      <div className="landing-footer-brand">
        <img
          src="/premios-logo.svg"
          alt="Premios NovaGob"
          className="landing-footer-logo"
        />
        <p className="landing-footer-tagline">
          <Sparkle size={14} strokeWidth={2} />
          El punto de encuentro de la innovación pública
        </p>
      </div>

      <nav className="landing-footer-socials" aria-label="Redes sociales">
        {SOCIALS.map(({ href, label, Icon }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="landing-footer-social"
          >
            <Icon size={18} />
          </a>
        ))}
      </nav>
    </div>

    <div className="landing-footer-divider" />

    <div className="landing-container landing-footer-bottom">
      <div className="landing-footer-copy">
        © {YEAR} NovaGob · Fundación NovaGob
      </div>
      <nav className="landing-footer-links" aria-label="Enlaces legales">
        <a
          href="https://novagob.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          novagob.org
        </a>
        <span aria-hidden="true">·</span>
        <a href="mailto:info@novagob.org">Contacto</a>
        <span aria-hidden="true">·</span>
        <a
          href="https://novagob.org/privacidad"
          target="_blank"
          rel="noopener noreferrer"
        >
          Política de privacidad
        </a>
        <span aria-hidden="true">·</span>
        <a
          href="https://novagob.org/terminos-y-condiciones"
          target="_blank"
          rel="noopener noreferrer"
        >
          Términos y condiciones
        </a>
      </nav>
    </div>
  </footer>
);

export default LandingFooter;
